import React from 'react';
import { useCurrentLanguage } from 'domain/selectors/page';

export default (Component: any) => {
  return function EnhancedComponent(props: any) {
    const currentLanguage = useCurrentLanguage();
    return <Component {...props} currentLanguage={currentLanguage} />;
  };
};
